import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { DEFAULT_VALUES } from './fixtures';
import { TestimonialsSection } from './TestimonialsSection';
import { COLOR_KEYS } from '../../../constants';

export default createBuilderModule(
  withTracking(TestimonialsSection, {
    sectionName: SectionName.TestimonialsSection,
  }),
  {
    name: 'TestimonialsSection',
    image: 'https://cdn.zappy.app/b7d72c7ef4b259c9e887bbae3c105295.svg',
    inputs: [
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.moss,
          COLOR_KEYS.neutral800,
          COLOR_KEYS.night,
          COLOR_KEYS.zapier,
        ],
        required: true,
        defaultValue: DEFAULT_VALUES.backgroundColor,
      },
      {
        name: 'heading',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.heading,
      },
      {
        name: 'description',
        type: 'richText',
        required: true,
        defaultValue: DEFAULT_VALUES.description,
      },
      {
        name: 'ctaText',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.ctaText,
      },
      {
        name: 'ctaUrl',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.ctaUrl,
      },
      {
        name: 'testimonials',
        type: 'list',
        subFields: [
          {
            name: 'quote',
            type: 'richText',
            required: true,
          },
          {
            name: 'author',
            type: 'string',
            required: true,
          },
          {
            name: 'logoUrl',
            type: 'cloudinaryImage',
            required: true,
          },
          {
            name: 'logoAltText',
            type: 'string',
            required: true,
          },
          {
            name: 'thumbnailUrl',
            type: 'cloudinaryImage',
            required: true,
          },
          {
            name: 'thumbnailAltText',
            type: 'string',
            required: true,
          },
        ],
        required: true,
        defaultValue: DEFAULT_VALUES.testimonials,
      },
    ],
  },
);
